import { http, HttpResponse } from 'msw'
import { StatusCodes } from 'http-status-codes'

import { allAllergens } from 'app/mocks/data/catalogue/products/allergens'
import { allSubcategories } from 'app/mocks/data/catalogue/products/subcategories'
import { allSuppliers } from 'app/mocks/data/catalogue/suppliers'
import { allClients } from 'app/mocks/data/park/clients'
import { allCategories } from 'app/mocks/data/users/categories'

import { formDataToData } from 'app/utils/app/requests'
import { api, assets } from 'app/utils/constants'

import { Product, ProductPayload } from 'app/types/catalogue/product'

export const createProduct = http.post(
    `${process.env.REACT_APP_API_ADDRESS}/${api.catalogue.products.LIST}`,
    async ({ request }) => {
        const payload = await request.formData()
        const productData = formDataToData(payload)
        const payloadParsed = ProductPayload.safeParse(productData)

        // Wrong payload
        if (!payloadParsed.data) {
            return HttpResponse.json(payloadParsed.error.issues, {
                status: StatusCodes.UNPROCESSABLE_ENTITY,
            })
        }

        return HttpResponse.json<Product>(
            {
                id: 999,
                ...payloadParsed.data,
                photo: assets.ethik.KONSOLE_COLOR,
                client: allClients.find(
                    (client) => client.id === payloadParsed.data.client,
                ),
                supplier: allSuppliers.find(
                    (supplier) => supplier.id === payloadParsed.data.client,
                ),
                category: allCategories.find(
                    (category) => category.id === payloadParsed.data.category,
                ),
                subcategory: allSubcategories.find(
                    (subcategory) =>
                        subcategory.id === payloadParsed.data.subcategory,
                ),
                allergens: allAllergens.filter((allergen) =>
                    payloadParsed.data.allergens.includes(allergen.id),
                ),
            },
            {
                status: StatusCodes.CREATED,
            },
        )
    },
)
